import dayjs from "dayjs";
import { fillingmodeOptions } from "../../Constant/Export/CreateNewJob/FilterBox";
import { FllingModeList } from "../../Constant/Export/CreateNewJob/FilterBox";
import { jobOwnerList } from "../../Constant/Export/CreateNewJob/FilterBox";

export const transportMode = [
  // { label: "All", value: "all" },
  { label: "Air", value: "air" },
  { label: "Sea", value: "sea" },
];
export const DOCUMENT_FIELDS = [
  "certificateofIncorporation",
  "memorandumofAssociation",
  "articlesofAssociation",
  "powerofAttorney",
  "copyofPANAllotment",
  "copyofTelephoneBill",
  "gSTRegistrationCopy",
  "balanceSheet",
];

export const transportModeFilter = [
  { label: "All", value: "" },
  { label: "Air", value: "air" },
  { label: "Sea", value: "sea" },
];
export const sbTypeOptions = [
  { label: "White - Free/DEEC", value: "white" },
  { label: "Green - Drawback", value: "green" },
  { label: "Blue - DEPB", value: "blue" },
  { label: "Yellow - Dutiable", value: "yellow" },
  { label: "Pink - ExBond", value: "pink" },
  { label: "SEZ - Regular", value: "sez_regular" },
  { label: "SEZ - ExBond", value: "sez_exbond" },
  { label: "SEZ - DTA Procurement", value: "sez_dta" },
];

export const customsHouse = {
  all: [
    // { label: "All", value: "all" },
    { label: "Bengaluru Air Cargo", value: "Bengaluru Air Cargo" },
    { label: "Bengaluru ICD", value: "Bengaluru ICD" },
    { label: "Chennai Air Cargo", value: "Chennai Air Cargo" },
    { label: "Chennai Sea", value: "Chennai Sea" },
    { label: "ICD HOSUR", value: "ICD HOSUR" },
    { label: "Kattupalli", value: "Kattupalli" },
    { label: "Nhava Sheva Sea", value: "Nhava Sheva Sea" },
    {
      label: "Primal Project Private Limited",
      value: "Primal Project Private Limited",
    },
    { label: "Visakhapatnam", value: "Visakhapatnam" },
    { label: "Vizag Sea", value: "Vizag Sea" },
  ],

  air: [
    // { label: "All", value: "all" },
    { label: "Bengaluru Air Cargo", value: "Bengaluru Air Cargo" },
    { label: "Chennai Air Cargo", value: "Chennai Air Cargo" },
    { label: "Visakhapatnam", value: "Visakhapatnam" },
  ],

  sea: [
    // { label: "All", value: "all" },
    { label: "Bengaluru ICD", value: "Bengaluru ICD" },
    { label: "Chennai Sea", value: "Chennai Sea" },
    { label: "ICD HOSUR", value: "ICD HOSUR" },
    { label: "Kattupalli", value: "Kattupalli" },
    { label: "Nhava Sheva Sea", value: "Nhava Sheva Sea" },
    {
      label: "Primal Project Private Limited",
      value: "Primal Project Private Limited",
    },
    { label: "Vizag Sea", value: "Vizag Sea" },
  ],
};

export const customsHouseFilter = {
  all: [
    { label: "All", value: "" },
    { label: "Bengaluru Air Cargo", value: "Bengaluru Air Cargo" },
    { label: "Bengaluru ICD", value: "Bengaluru ICD" },
    { label: "Chennai Air Cargo", value: "Chennai Air Cargo" },
    { label: "Chennai Sea", value: "Chennai Sea" },
    { label: "ICD HOSUR", value: "ICD HOSUR" },
    { label: "Kattupalli", value: "Kattupalli" },
    { label: "Nhava Sheva Sea", value: "Nhava Sheva Sea" },
    {
      label: "Primal Project Private Limited",
      value: "Primal Project Private Limited",
    },
    { label: "Visakhapatnam", value: "Visakhapatnam" },
    { label: "Vizag Sea", value: "Vizag Sea" },
  ],

  air: [
    { label: "All", value: "" },
    { label: "Bengaluru Air Cargo", value: "Bengaluru Air Cargo" },
    { label: "Chennai Air Cargo", value: "Chennai Air Cargo" },
    { label: "Visakhapatnam", value: "Visakhapatnam" },
  ],

  sea: [
    { label: "All", value: "" },
    { label: "Bengaluru ICD", value: "Bengaluru ICD" },
    { label: "Chennai Sea", value: "Chennai Sea" },
    { label: "ICD HOSUR", value: "ICD HOSUR" },
    { label: "Kattupalli", value: "Kattupalli" },
    { label: "Nhava Sheva Sea", value: "Nhava Sheva Sea" },
    {
      label: "Primal Project Private Limited",
      value: "Primal Project Private Limited",
    },
    { label: "Vizag Sea", value: "Vizag Sea" },
  ],
};

export const defaultValues = {
  exportJobDate: dayjs(), // today
  exportJobReceivedOn: dayjs(), // current date-time
  exportJOBOwner: jobOwnerList[0]?.value || "",
  exporterJobFillingMode: fillingmodeOptions[0]?.value || "",
  exporterJobFillingType: FllingModeList[0]?.value || "",
  exportTransportMode: "air",
  exportCustomHouse: "Bengaluru Air Cargo",
  exportLoadingPortId: "688b468988447da911802315",
  exportSBType: sbTypeOptions[0]?.value || "",
};

export const importdefaultValues = {
  importJobDate: dayjs(), // today
  importJobReceivedOn: dayjs(), // current date-time
  importJobOwner: jobOwnerList[0]?.value || "",
  importJobFillingMode: fillingmodeOptions[0]?.value || "",
  importJobFillingModeType: FllingModeList[0]?.value || "",
  importJobTransportMode: "air",
  importJobCustomHouse: "Bengaluru Air Cargo",
  // exportLoadingPortId: "688b469088447da9118023be",
  importJobBEType: sbTypeOptions[0]?.value || "",
};

const items = [
  "Free SB Involving Remittance Of Foreign Exchange",
  "Advance License With Actual User Condition",
  "Advance License For Intermediate Supplies",
  "Advance License",
  "Advance Release Order",
  "Advance License For Deemed Exports",
  "DEPB Post Export",
  "DEPB-Pre Export",
  "Replenishment Licence",
  "Diamond Imprest Licence",
  "Bulk License",
  "Concessional Duty EPCG Scheme",
  "Zero Duty EPCG Scheme",
  "CCP",
  "Import License For Restricted Items Of Imports",
  "Special Import License",
  "Export License",
  "Advance Licence for annual requirement",
  "Drawback",
  "Jobbing(JBG)",
  "EOU/EPZ/SEZ/EHTP/STP",
  "Duty Free Credit Entitlement Certificate",
  "Target Plus Scheme",
  "Vishesh Krishi Upaj Yojana (VKUY)",
  "DFCE for Status holder",
  "Duty Free Import Authorization",
  "Focus Market Scheme",
  "Focus Product Scheme",
  "High Tech Products Export Promotion Scheme",
  "EPCG Duty Based",
  "Status Holder Incentive Scheme",
  "Tariff Quota",
  "Incremental Incentivisation Scheme",
  "Rebate of State and Central Taxes Levies",
  "DBK and Advance Licence for annual requirement",
  "Drawback And Advance License",
  "Drawback And Zero Duty EPCG",
  "Drawback And Concessional Duty EPCG",
  "Drawback And Pre Export DEPB",
  "Drawback And Post Export DEPB",
  "Drawback And JBG",
  "Drawback And Diamond Imprest Licence",
  "Drawback And EOU/EPZ/SEZ",
  "EPCG And Advance Licence",
  "EPCG and JBG",
  "EPCG And Diamond Imprest Licence",
  "EPCG And Replenishment Licence",
  "EPCG and DEPB(Post Exports)",
  "EPCG and Advance Licence for annual requirement",
  "EPCG and DFIA",
  "Drawback,and ROSCTL",
  "EPCG,Drawback and ROSCTL",
  "Drawback and special DEEC(4.04A)",
  "EPCG,Drawback and special DEEC(4.04A)",
  "Drawback,special DEEC(4.04A) and ROSCTL",
  "EPCG,Drawback,special DEEC(4.04A) and ROSCTL",
  "EPCG,Drawback And DEEC",
  "EPCG,DRAWBACK And Jobbing",
  "EPCG Drawback And Diamond Imprest Licence",
  "EPCG Drawback And DEPB Post Export",
  "Epcg, Drawback And Depb (Pre-export)",
  "EPCG ,Drawback and DFIA",
  "EPCG,Drawback and Advance Licence for annual requirement",
  "DFIA and Drawback",
  "Free Shipping Bill involving Indian Currency",
  "NFEI",
  "Prohibited Imports",
  "Project Import",
  "RoDTEP Scheme",
  "RoSCTL Scheme",
];

// const { data: eximApiData } = useGetEximCodeQuery();
// console.log("eximApiData", eximApiData);

export const eximCodeTabMap = {
  "Advance License With Actual User Condition": ["  "],
  "Advance License For Intermediate Supplies": ["deec"],
  "Advance License": ["deec"],
  "Advance Release Order": ["deec"],
  "Advance License For Deemed Exports": ["deec"],
  "DEPB Post Export": ["depb"],
  "DEPB-Pre Export": ["depb"],
  "Concessional Duty EPCG Scheme": ["epcg"],
  "Zero Duty EPCG Scheme": ["epcg"],
  "Advance Licence for annual requirement": ["deec"],
  Drawback: ["productdrawback"],
  "Jobbing(JBG)": ["productdrawback"],
  "DFCE for Status holder": ["dfia"],
  "Duty Free Import Authorization": ["dfia"],
  "Drawback And Advance License": ["deec"],
  "Drawback And Zero Duty EPCG": ["dfrc"],
  "Drawback And Concessional Duty EPCG": ["epcg"],
  "Drawback And Post Export DEPB": ["depb"],
  "Drawback And JBG": ["productdrawback"],
  "Drawback And Diamond Imprest Licence": ["productdrawback"],
  "Drawback And EOU/EPZ/SEZ": ["productdrawback"],
  "EPCG And Advance Licence": ["epcg", "deec"],
  "EPCG and JBG": ["epcg"],
  "EPCG And Diamond Imprest Licence": ["epcg"],
  "EPCG And Replenishment Licence": ["epcg"],
  "EPCG and DEPB(Post Exports)": ["epcg", "depb"],
  "EPCG and Advance Licence for annual requirement": ["epcg", "deec"],
  "EPCG and DFIA": ["epcg", "dfia"],
  "Drawback,and ROSCTL": ["productdrawback"],
  "EPCG,Drawback and ROSCTL": ["epcg", "productdrawback"],
  "Drawback and special DEEC(4.04A)": ["productdrawback", "epcg", "deec"],
  "EPCG,Drawback and special DEEC(4.04A)": ["productdrawback", "epcg"],
  "Drawback,special DEEC(4.04A) and ROSCTL": ["productdrawback", "deec"],
  "EPCG,Drawback,special DEEC(4.04A) and ROSCTL": [
    "productdrawback",
    "epcg",
    "deec",
  ],
  "EPCG,Drawback And DEEC": ["productdrawback", "epcg", "deec"],
  "EPCG,DRAWBACK And Jobbing": ["productdrawback", "epcg"],
  "EPCG Drawback And Diamond Imprest Licence": ["productdrawback", "epcg"],
  "EPCG Drawback And DEPB Post Export": ["productdrawback", "epcg"],
  "Epcg, Drawback And Depb (Pre-export)": ["productdrawback", "epcg"],
  "EPCG ,Drawback and DFIA": ["productdrawback", "epcg"],
  "EPCG,Drawback and Advance Licence for annual requirement": [
    "productdrawback",
    "epcg",
  ],
  "DFIA and Drawback": ["dfia", "productdrawback"],
};

const createReverseMap = (map) => {
  const reverse = {};

  for (const [dropdown, tabs] of Object.entries(map)) {
    tabs.forEach((tab) => {
      if (!reverse[tab]) reverse[tab] = [];
      reverse[tab].push(dropdown);
    });
  }

  return reverse;
};
export const getEximValue = (eximCode) =>
  typeof eximCode === "string" ? eximCode : eximCode?.value;


// ✅ call it once
export const tabToEximCodeMap = createReverseMap(eximCodeTabMap);


export const deecVisibleData = [
  "Advance License With Actual User Condition",

  "Advance License For Intermediate Supplies",

  "Advance License",

  "Advance Release Order",

  "Advance License For Deemed Exports",

  "Advance Licence for annual requirement",

  "Drawback And Advance License",

  "EPCG And Advance Licence",

  "EPCG and Advance Licence for annual requirement",

  "Drawback and special DEEC(4.04A)",

  "Drawback,special DEEC(4.04A) and ROSCTL",

  "EPCG,Drawback,special DEEC(4.04A) and ROSCTL",

  "EPCG,Drawback And DEEC",
];

export const epcgVisibleData = [
  "Concessional Duty EPCG Scheme",

  "Zero Duty EPCG Scheme",

  "Drawback And Concessional Duty EPCG",

  "EPCG And Advance Licence",

  "EPCG and JBG",

  "EPCG And Diamond Imprest Licence",

  "EPCG And Replenishment Licence",

  "EPCG and DEPB(Post Exports)",

  "EPCG and Advance Licence for annual requirement",

  "EPCG and DFIA",
  "EPCG,Drawback and ROSCTL",

  "Drawback and special DEEC(4.04A)",

  "EPCG,Drawback and special DEEC(4.04A)",

  "EPCG,Drawback,special DEEC(4.04A) and ROSCTL",

  "EPCG,Drawback And DEEC",

  "EPCG,DRAWBACK And Jobbing",

  "EPCG Drawback And Diamond Imprest Licence",

  "EPCG Drawback And DEPB Post Export",

  "Epcg, Drawback And Depb (Pre-export)",

  "EPCG ,Drawback and DFIA",

  "EPCG,Drawback and Advance Licence for annual requirement",
];


export const drawBackVisibleData = [ 
"Drawback",
"Jobbing(JBG)",
"Drawback And JBG",
"Drawback And Diamond Imprest Licence",
"Drawback And EOU/EPZ/SEZ",
"Drawback,and ROSCTL",
"EPCG,Drawback and ROSCTL", 
"Drawback and special DEEC(4.04A)",
"EPCG,Drawback and special DEEC(4.04A)",
"Drawback,special DEEC(4.04A) and ROSCTL",
"EPCG,Drawback,special DEEC(4.04A) and ROSCTL",
"EPCG,Drawback And DEEC",
"EPCG,DRAWBACK And Jobbing",
"EPCG Drawback And Diamond Imprest Licence", 
"EPCG Drawback And DEPB Post Export",
"Epcg, Drawback And Depb (Pre-export)",
"EPCG ,Drawback and DFIA",
"EPCG,Drawback and Advance Licence for annual requirement",
"DFIA and Drawback"
];

export const dfiaVisibleData = [
"DFCE for Status holder",
"Duty Free Import Authorization",
"EPCG and DFIA",
"DFIA and Drawback"
]

export const depbVisibleData = [
"DEPB Post Export",
"DEPB-Pre Export",
"Drawback And Post Export DEPB",
"EPCG and DEPB(Post Exports)"
]